<template>
  <div class="card product-teaser" :class="compact ? 'compact' : 'extended'" @click="$emit('click')">
    <div
      :style="`background-image: url(https://storage.googleapis.com/emma-static/products/${product.img}_1200.jpg)`"
      class="card-img-top product-img"
      alt="..."
    />
    <div class="card-body">
      <span class="badge badge-danger mr-1 mb-2" v-if="product.status.discontinued">Discontinued</span>
      <span class="badge badge-warning mb-2" v-if="product.temporarilyUnavailable">Temp. Unavailable</span>
      <h4 class="card-title product-title">{{ product.brandName }} {{ product.label }}</h4>
      <p class="card-text product-size">{{ product.packageSize }} {{ product.packageUnit }}</p>
      <span
        class="badge badge-pill amount"
        v-if="amount"
        :class="amount.total > amount.current ? 'badge-warning' : 'badge-success'"
        >{{ amount.current }} / {{ amount.total }}</span
      >
      <div class="product-teaser__supply" v-if="!compact">
        <span class="product-teaser__supply__item"
          >{{ stockCount }}<span class="product-teaser__supply__item__label">In Stock</span></span
        >
        <span class="product-teaser__supply__separator">-</span>
        <span
          class="product-teaser__supply__item"
          :class="`product-teaser__supply__item--${demandCount > stockCount ? 'warning' : ''}`"
          >{{ demandCount }}<span class="product-teaser__supply__item__label">Demand</span></span
        >
        <span class="product-teaser__supply__separator">=</span>
        <span
          class="product-teaser__supply__item"
          :class="`product-teaser__supply__item--${supply >= 0 ? 'success' : 'warning'}`"
          >{{ supply }}<span class="product-teaser__supply__item__label">Supply</span></span
        >
      </div>
      <button class="btn btn-primary" v-if="showStoreButton" @click="$emit('store-button-click')">Store Product</button>
    </div>
  </div>
</template>

<script>
import { ItemsInStock, ItemsInDemand } from '@/helpers/Calculator'

export default {
  props: ['amount', 'productId', 'showStoreButton', 'compact'],
  computed: {
    product() {
      const product = this.$store.state.products.find(p => p.id === this.productId)

      return product
    },
    stockCount() {
      if (!this.$store.getters.isLoaded('shelves')) return null
      return ItemsInStock(this.$store.state.shelves)[this.productId] || 0
    },
    demandCount() {
      if (!this.$store.getters.isLoaded('orders')) return null
      return ItemsInDemand(this.$store.state.orders)[this.productId] || 0
    },
    supply() {
      if (this.stockCount === null || this.demandCount === null) return null
      return this.stockCount - this.demandCount
    }
  }
}
</script>

<style lang="scss" scoped>
.product-teaser {
  flex-direction: row;
  align-items: center;

  &.compact {
    .product-img {
      width: 8rem;
      height: 8rem;
      margin: 0.5rem;
    }

    .card-body {
      padding: 0.5rem;
    }

    .amount {
      display: inline-block;
      margin: 0.5rem 0 0;
      font-size: 1rem;
    }

    .product-title {
      font-size: 20px;
      margin: 0;
      display: inline;
    }
    .product-size {
      display: inline;
      &:before {
        content: ', ';
      }
    }
  }
  &__supply {
    display: flex;
    align-items: center;

    font-size: 1.5rem;
    &__item {
      text-align: center;
      background: #eee;
      padding: 0.4rem;
      border-radius: 0.3125rem;
      min-width: 3.1rem;

      &--warning {
        background: $color-alert-yellow;
      }
      &--success {
        background: $color-success-green;
        color: #fff;
      }
      &__label {
        display: block;

        font-size: 0.4em;
        font-weight: $weight-bold;
      }
    }
    &__separator {
      margin: 0 0.75rem;
    }
  }
}

.product-img {
  width: 12rem;
  height: 12rem;
  margin: 1rem;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
}
@media (max-width: 40rem) {
  .product-teaser {
    &.extended {
      flex-direction: column;

      .product-img {
        width: 8rem;
        height: 8rem;
        margin: 0.5rem 0 -0.5rem;
      }
    }

    &.compact {
      .product-img {
        width: 4rem;
        height: 4rem;
      }

      .product-title {
        font-size: 16px;
      }

      .amount {
        font-size: 0.75rem;
      }
    }
  }
}
</style>
